import { APP_ROUTES_RECP_DOC_TEMP } from '@/src/constants/routes'
import { useConsentForms, useDocTemplate } from '@/src/hooks'
import { CheckBox, FormButton, Loader, Modal } from '@ui'
import { getError, showToast } from '@util'
import { Box, Text } from 'grommet'
import { useMemo, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

type Props = {
  onClose: () => void
  id?: string
}

export const AddTemplate = ({ onClose }: Props) => {
  const { addConsent } = useConsentForms()
  const { patientId: patient_id, intakeId } = useParams<string>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [selectedTemplate, setSelectedTemplate] = useState<string[]>([])
  const intake_id = searchParams.get('intake_id') || intakeId || ''
  const { documents, documentIsLoading } = useDocTemplate({ intake_id: intake_id || intakeId })
  const options = useMemo(() => {
    if (documents) {
      return documents?.map(({ id, attributes: { title } }) => ({
        id,
        label: title
      }))
    } else return []
  }, [documents])

  const onChange = (id: string, checked: boolean) => {
    if (checked) {
      setSelectedTemplate(prev => {
        const newArray = [...prev, id]
        console.log('Selected templates:', newArray)
        return newArray
      })
    } else {
      setSelectedTemplate(prev => {
        const newArray = prev.filter(templateId => templateId !== id)
        console.log('Selected templates:', newArray)
        return newArray
      })
    }
  }
  const onSubmit = async () => {
    if (selectedTemplate?.length < 1) return

    const payload = selectedTemplate?.map(select => ({
      document_template_id: select,
      intake_id,
      patient_id
    }))
    setIsLoading(true)

    try {
      await addConsent({ consent_forms: payload })
      onClose()
      showToast('Template added successfully')
    } catch (error) {
      getError(error)
    }
    setIsLoading(false)
  }
  const hasTemplates = options.length > 0
  const handlePrimaryAction = () => {
    if (hasTemplates) {
      void onSubmit()
      return
    }
    onClose()
    navigate(APP_ROUTES_RECP_DOC_TEMP)
  }

  return (
    <Modal onClose={onClose} title="Add Template">
      {documentIsLoading ? (
        <div className="max-h-20">
          <Loader />
        </div>
      ) : (
        <div className="flex flex-col md:w-full max-w-[550px] w-full">
          <div className="flex flex-col overflow-auto gap-6 p-6">
            {hasTemplates ? (
              options?.map(({ id, label }) => (
                <Box direction="row" gap={'4px'} justify="between" key={id}>
                  <Text size="small">
                    <label htmlFor={label}>{label}</label>
                  </Text>
                  <CheckBox
                    defaultCheck={selectedTemplate.includes(id)}
                    handleChange={checked => onChange(id, checked)}
                  />
                </Box>
              ))
            ) : (
              <Text size="small">No document templates found.</Text>
            )}
          </div>
          <FormButton
            isLoading={isLoading}
            onClick={handlePrimaryAction}
            onClose={onClose}
            submit={hasTemplates ? 'Add' : 'To Doc Temp'}
          />
        </div>
      )}
    </Modal>
  )
}
